import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > div:first-child {
    .ant-btn-text {
      color: ${({ theme }) => theme.colors.tone.red};
    }
  }

  & > div:not(:last-child) {
    margin-right: 8px;
  }
`;
